export default "__VITE_ASSET__Dka86W3V__"